export default [
  {
    path: '/x/pcr',
    name: 'pcr',
    component: () => import('@/views/pcr'),
    redirect: '/x/pcr/task-list',
    children: [
      {
        path: 'custom-list',
        name: 'pcr-custom-list',
        component: () => import('@/views/pcr/pcr-custom-list.vue'),
      },
      {
        path: 'custom-detail/:id',
        name: 'pcr-custom-detail',
        component: () => import('@/views/pcr/pcr-custom-detail.vue'),
      },
      {
        path: 'task-list',
        name: 'pcr-task-list',
        component: () => import('@/views/pcr/pcr-task-list.vue'),
      },
      {
        path: 'task-detail/:id',
        name: 'pcr-task-detail',
        component: () => import('@/views/pcr/pcr-task-detail.vue'),
      },
      {
        path: 'texture-list',
        name: 'pcr-texture-list',
        component: () => import('@/views/pcr/pcr-texture-list.vue'),
      },
      {
        path: 'texture-piece',
        name: 'pcr-texture-piece',
        component: () => import('@/views/pcr/pcr-texture-piece.vue'),
      },
    ],
  },
];
